// This file is auto-generated by @hey-api/openapi-ts
import { createClient, createConfig } from '@hey-api/client-fetch';
export const client = createClient(createConfig());
export const healthControllerHealth = (options) => {
    return (options?.client ?? client).get({
        ...options,
        url: '/health'
    });
};
/**
 * 윈도우 수신기 토큰 로그인
 * Settings > 수집에서 발급/재발급한 수신기 토큰으로 윈도우 수신기를 인증합니다.
 */
export const agentAuthControllerTokenLogin = (options) => {
    return (options?.client ?? client).post({
        ...options,
        url: '/v2/agent/auth/token-login'
    });
};
/**
 * 운영자 (admin.dvvb.io) 로그인
 * users.is_platform_admin=true user 만 통과. 사장/직원은 401. admin_sessions row insert + JWT 발급.
 */
export const adminAuthControllerLogin = (options) => {
    return (options?.client ?? client).post({
        ...options,
        url: '/v2/admin/auth/login'
    });
};
/**
 * 현재 사용자·소속 회사·매장
 */
export const userControllerMe = (options) => {
    return (options?.client ?? client).get({
        ...options,
        url: '/me'
    });
};
/**
 * 플랫폼 목록 (회사별)
 * 현재 회사가 직접 등록한 플랫폼 목록입니다. 새 회사는 플랫폼 없이 시작합니다. displayOrder ASC, id ASC.
 */
export const platformsControllerList = (options) => {
    return (options?.client ?? client).get({
        ...options,
        url: '/v1/platforms'
    });
};
/**
 * 플랫폼 신규 등록 (회사별)
 * owner 만 가능. 등록된 플랫폼은 현재 회사 안에서만 사용됩니다.
 */
export const platformsControllerCreate = (options) => {
    return (options?.client ?? client).post({
        ...options,
        url: '/v1/platforms'
    });
};
/**
 * 플랫폼 단건
 */
export const platformsControllerGet = (options) => {
    return (options?.client ?? client).get({
        ...options,
        url: '/v1/platforms/{id}'
    });
};
/**
 * 플랫폼 갱신 (회사별)
 */
export const platformsControllerUpdate = (options) => {
    return (options?.client ?? client).patch({
        ...options,
        url: '/v1/platforms/{id}'
    });
};
/**
 * 플랫폼 삭제 (회사별)
 * 현재 회사의 stores 가 참조 중이면 삭제 거부 (PLATFORM_IN_USE).
 */
export const platformsControllerRemove = (options) => {
    return (options?.client ?? client).delete({
        ...options,
        url: '/v1/platforms/{id}'
    });
};
/**
 * 선택 사업장 판매채널 목록
 * 선택한 사업장에 연결된 판매채널만 반환합니다. 회사 전체 플랫폼 목록을 그대로 반환하지 않습니다.
 */
export const locationSalesChannelsControllerList = (options) => {
    return (options?.client ?? client).get({
        ...options,
        url: '/v1/locations/{locationId}/sales-channels'
    });
};
/**
 * 선택 사업장 판매채널 생성
 * owner 가 입력한 판매채널 이름으로 회사 채널을 만들거나 재사용한 뒤, 선택한 사업장에 연결합니다.
 */
export const locationSalesChannelsControllerCreate = (options) => {
    return (options?.client ?? client).post({
        ...options,
        url: '/v1/locations/{locationId}/sales-channels'
    });
};
/**
 * 선택 사업장 판매채널 연결 해제
 * 선택한 사업장에서만 판매채널 연결을 해제합니다. 같은 회사의 채널 마스터를 삭제하지 않습니다.
 */
export const locationSalesChannelsControllerRemove = (options) => {
    return (options?.client ?? client).delete({
        ...options,
        url: '/v1/locations/{locationId}/sales-channels/{platformId}'
    });
};
/**
 * 사업장 목록
 */
export const locationsControllerList = (options) => {
    return (options?.client ?? client).get({
        ...options,
        url: '/v1/locations'
    });
};
/**
 * 사업장 생성
 */
export const locationsControllerCreate = (options) => {
    return (options?.client ?? client).post({
        ...options,
        url: '/v1/locations'
    });
};
/**
 * 사업장 단건
 */
export const locationsControllerGet = (options) => {
    return (options?.client ?? client).get({
        ...options,
        url: '/v1/locations/{id}'
    });
};
/**
 * 사업장 갱신
 */
export const locationsControllerUpdate = (options) => {
    return (options?.client ?? client).patch({
        ...options,
        url: '/v1/locations/{id}'
    });
};
/**
 * 사업장 삭제 (soft)
 */
export const locationsControllerRemove = (options) => {
    return (options?.client ?? client).delete({
        ...options,
        url: '/v1/locations/{id}'
    });
};
/**
 * 매장 목록
 */
export const storesControllerList = (options) => {
    return (options?.client ?? client).get({
        ...options,
        url: '/v1/stores'
    });
};
/**
 * 매장 생성
 */
export const storesControllerCreate = (options) => {
    return (options?.client ?? client).post({
        ...options,
        url: '/v1/stores'
    });
};
/**
 * 매장 단건
 */
export const storesControllerGet = (options) => {
    return (options?.client ?? client).get({
        ...options,
        url: '/v1/stores/{id}'
    });
};
/**
 * 매장 갱신
 */
export const storesControllerUpdate = (options) => {
    return (options?.client ?? client).patch({
        ...options,
        url: '/v1/stores/{id}'
    });
};
/**
 * 매장 삭제 (soft)
 */
export const storesControllerRemove = (options) => {
    return (options?.client ?? client).delete({
        ...options,
        url: '/v1/stores/{id}'
    });
};
/**
 * 회사 마스터 메뉴 목록 (Phase 6.D-2)
 */
export const menusControllerListMaster = (options) => {
    return (options?.client ?? client).get({
        ...options,
        url: '/v1/menus'
    });
};
/**
 * 회사 마스터 메뉴 등록 (Phase 6.D-2)
 */
export const menusControllerCreateMaster = (options) => {
    return (options?.client ?? client).post({
        ...options,
        url: '/v1/menus'
    });
};
export const menusControllerGet = (options) => {
    return (options?.client ?? client).get({
        ...options,
        url: '/v1/menus/{id}'
    });
};
export const menusControllerUpdate = (options) => {
    return (options?.client ?? client).patch({
        ...options,
        url: '/v1/menus/{id}'
    });
};
export const menusControllerRemove = (options) => {
    return (options?.client ?? client).delete({
        ...options,
        url: '/v1/menus/{id}'
    });
};
/**
 * 매장 노출 메뉴 (active StoreMenu join)
 * Phase 6.D-2 — 매장에 link 된 active StoreMenu 의 회사 마스터 메뉴를 반환.
 */
export const menusControllerListByStore = (options) => {
    return (options?.client ?? client).get({
        ...options,
        url: '/v1/stores/{storeId}/menus'
    });
};
/**
 * (DEPRECATED) 매장 단위 메뉴 등록
 * Phase 6.D-2 백워드 호환. 회사 마스터 신규 + StoreMenu link 까지 자동. 신규 코드는 POST /v1/menus + POST /v1/stores/:storeId/store-menus 사용.
 */
export const menusControllerCreateForStore = (options) => {
    return (options?.client ?? client).post({
        ...options,
        url: '/v1/stores/{storeId}/menus'
    });
};
/**
 * 메뉴 카테고리 목록 (회사)
 */
export const menuCategoriesControllerList = (options) => {
    return (options?.client ?? client).get({
        ...options,
        url: '/v1/menu-categories'
    });
};
/**
 * 메뉴 카테고리 신규
 */
export const menuCategoriesControllerCreate = (options) => {
    return (options?.client ?? client).post({
        ...options,
        url: '/v1/menu-categories'
    });
};
export const menuCategoriesControllerGet = (options) => {
    return (options?.client ?? client).get({
        ...options,
        url: '/v1/menu-categories/{id}'
    });
};
export const menuCategoriesControllerUpdate = (options) => {
    return (options?.client ?? client).patch({
        ...options,
        url: '/v1/menu-categories/{id}'
    });
};
export const menuCategoriesControllerRemove = (options) => {
    return (options?.client ?? client).delete({
        ...options,
        url: '/v1/menu-categories/{id}'
    });
};
/**
 * 매장 메뉴 link 목록
 */
export const storeMenusControllerList = (options) => {
    return (options?.client ?? client).get({
        ...options,
        url: '/v1/stores/{storeId}/store-menus'
    });
};
/**
 * 매장-메뉴 link
 */
export const storeMenusControllerCreate = (options) => {
    return (options?.client ?? client).post({
        ...options,
        url: '/v1/stores/{storeId}/store-menus'
    });
};
export const storeMenusControllerGet = (options) => {
    return (options?.client ?? client).get({
        ...options,
        url: '/v1/store-menus/{id}'
    });
};
export const storeMenusControllerUpdate = (options) => {
    return (options?.client ?? client).patch({
        ...options,
        url: '/v1/store-menus/{id}'
    });
};
export const storeMenusControllerRemove = (options) => {
    return (options?.client ?? client).delete({
        ...options,
        url: '/v1/store-menus/{id}'
    });
};
/**
 * 발주 목록 (createdAt desc)
 */
export const ordersControllerList = (options) => {
    return (options?.client ?? client).get({
        ...options,
        url: '/v1/orders'
    });
};
/**
 * 발주 신규 (manual)
 */
export const ordersControllerCreate = (options) => {
    return (options?.client ?? client).post({
        ...options,
        url: '/v1/orders'
    });
};
export const ordersControllerGet = (options) => {
    return (options?.client ?? client).get({
        ...options,
        url: '/v1/orders/{id}'
    });
};
/**
 * 발주 갱신 (status / 시각 / notes)
 */
export const ordersControllerUpdate = (options) => {
    return (options?.client ?? client).patch({
        ...options,
        url: '/v1/orders/{id}'
    });
};
/**
 * 발주 취소 (soft, status=cancelled)
 */
export const ordersControllerRemove = (options) => {
    return (options?.client ?? client).delete({
        ...options,
        url: '/v1/orders/{id}'
    });
};
export const recipesControllerList = (options) => {
    return (options?.client ?? client).get({
        ...options,
        url: '/v1/menus/{menuId}/recipes'
    });
};
export const recipesControllerCreate = (options) => {
    return (options?.client ?? client).post({
        ...options,
        url: '/v1/menus/{menuId}/recipes'
    });
};
export const recipesControllerGet = (options) => {
    return (options?.client ?? client).get({
        ...options,
        url: '/v1/recipes/{id}'
    });
};
export const recipesControllerUpdate = (options) => {
    return (options?.client ?? client).patch({
        ...options,
        url: '/v1/recipes/{id}'
    });
};
export const recipesControllerRemove = (options) => {
    return (options?.client ?? client).delete({
        ...options,
        url: '/v1/recipes/{id}'
    });
};
/**
 * BoxHero 품목 미러 요약 (= '현재재고' 탭 KPI)
 * total = mirror row 수 / totalValue = Σ mirror.quantity * mirror.cost.
 */
export const inventoryControllerItemsSummary = (options) => {
    return (options?.client ?? client).get({
        ...options,
        url: '/v1/inventory/items/summary'
    });
};
/**
 * BoxHero 품목 미러 목록 (= '현재재고' 탭 source)
 * provider_item_mirror 영역 영역 SELECT (RLS 적용). worker initial-sync · item* webhook · 15분 polling 영역 영역 BoxHero items 응답 1:1 mirror. N3.1 (2026-05-09) — locationId query param = BoxHero raw bigint string (= BoxHero location id). 미지정 = '모든위치' = 합산.
 */
export const inventoryControllerListItems = (options) => {
    return (options?.client ?? client).get({
        ...options,
        url: '/v1/inventory/items'
    });
};
/**
 * BoxHero 위치 list (= '현재재고' 탭 위치 selector source)
 * 회사 token 으로 BoxHero `/v1/locations` 를 조회해 응답. 사용자 dictation: '여기는 외부 박스히어로의 자료만 가져오는 곳' / '거기에 위치가 여러개가 있으면 어쩔려구?'. 회사 BoxHero 등록 위치 N 개 영역 영역 모두 표시.
 */
export const inventoryControllerListLocations = (options) => {
    return (options?.client ?? client).get({
        ...options,
        url: '/v1/inventory/locations'
    });
};
/**
 * 우리 사업장 ↔ BoxHero 위치 연동 상태
 * 재료 탭 연동 팝업 source. 새 테이블 없이 locations.boxheroLocationId 와 inventory(providerKind='boxhero') count 를 합쳐 반환한다.
 */
export const inventoryControllerListLocationMappings = (options) => {
    return (options?.client ?? client).get({
        ...options,
        url: '/v1/inventory/location-mappings'
    });
};
/**
 * BoxHero 입출고 로그 시계열
 * provider_tx_logs 시간 desc. type 필터 + cursor 페이지네이션. 기본 limit 30.
 */
export const inventoryControllerTxLogs = (options) => {
    return (options?.client ?? client).get({
        ...options,
        url: '/v1/inventory/tx-logs'
    });
};
/**
 * 재료 목록 (= '재료' 탭 source, 신설 inventory table)
 * inventory 영역 영역 SELECT (RLS 적용). 단순 list.
 */
export const inventoryControllerListMaterials = (options) => {
    return (options?.client ?? client).get({
        ...options,
        url: '/v1/inventory/materials'
    });
};
/**
 * 재료 등록 (= 사장 modal)
 * 사장 modal 영역 영역 input → inventory row 생성 (= ALGORITHM_FLOW v0.49 등록 [5] 단계).
 */
export const inventoryControllerCreateMaterial = (options) => {
    return (options?.client ?? client).post({
        ...options,
        url: '/v1/inventory/materials'
    });
};
/**
 * 재료 단건 조회
 */
export const inventoryControllerGetMaterial = (options) => {
    return (options?.client ?? client).get({
        ...options,
        url: '/v1/inventory/materials/{id}'
    });
};
/**
 * 재료 수정
 */
export const inventoryControllerUpdateMaterial = (options) => {
    return (options?.client ?? client).patch({
        ...options,
        url: '/v1/inventory/materials/{id}'
    });
};
/**
 * 재료 soft delete
 */
export const inventoryControllerRemoveMaterial = (options) => {
    return (options?.client ?? client).delete({
        ...options,
        url: '/v1/inventory/materials/{id}'
    });
};
/**
 * 재료 이미지 업로드
 * 새 테이블 없이 /uploads/inventory 아래 파일을 저장하고 imageUrl 만 반환한다. 반환된 URL 은 재료 등록/수정 metadata.imageUrl 로 저장한다.
 */
export const inventoryControllerUploadMaterialImage = (options) => {
    return (options?.client ?? client).post({
        ...options,
        url: '/v1/inventory/materials/image'
    });
};
/**
 * 재료 수동 입고/재고 조정
 * 새 테이블 없이 inventory.stock 을 증감하고 stock_movements 에 기록한다. qty 양수 = 입고/증가, qty 음수 = 조정 차감.
 */
export const inventoryControllerAdjustMaterialStock = (options) => {
    return (options?.client ?? client).post({
        ...options,
        url: '/v1/inventory/materials/{id}/stock-adjustments'
    });
};
export const suppliersControllerList = (options) => {
    return (options?.client ?? client).get({
        ...options,
        url: '/v1/suppliers'
    });
};
export const suppliersControllerCreate = (options) => {
    return (options?.client ?? client).post({
        ...options,
        url: '/v1/suppliers'
    });
};
export const suppliersControllerGet = (options) => {
    return (options?.client ?? client).get({
        ...options,
        url: '/v1/suppliers/{id}'
    });
};
export const suppliersControllerUpdate = (options) => {
    return (options?.client ?? client).patch({
        ...options,
        url: '/v1/suppliers/{id}'
    });
};
export const suppliersControllerRemove = (options) => {
    return (options?.client ?? client).delete({
        ...options,
        url: '/v1/suppliers/{id}'
    });
};
export const staffControllerList = (options) => {
    return (options?.client ?? client).get({
        ...options,
        url: '/v1/staff'
    });
};
export const staffControllerCreate = (options) => {
    return (options?.client ?? client).post({
        ...options,
        url: '/v1/staff'
    });
};
export const staffControllerGet = (options) => {
    return (options?.client ?? client).get({
        ...options,
        url: '/v1/staff/{id}'
    });
};
export const staffControllerUpdate = (options) => {
    return (options?.client ?? client).patch({
        ...options,
        url: '/v1/staff/{id}'
    });
};
export const staffControllerRemove = (options) => {
    return (options?.client ?? client).delete({
        ...options,
        url: '/v1/staff/{id}'
    });
};
/**
 * 영수증 raw payload 수신
 * 수신기 토큰으로 인증된 raw receipt upload. 이중 dedup (Idempotency-Key + raw_checksum). 202 Accepted + envelope.
 */
export const ingestControllerIngest = (options) => {
    return (options?.client ?? client).post({
        ...options,
        url: '/v2/agent/uploads/receipt-raw'
    });
};
/**
 * 수신기 기기 목록
 */
export const collectControllerListReceivers = (options) => {
    return (options?.client ?? client).get({
        ...options,
        url: '/v1/collect/receivers'
    });
};
/**
 * 수신기 기기 생성 + 토큰 발급
 */
export const collectControllerCreateReceiver = (options) => {
    return (options?.client ?? client).post({
        ...options,
        url: '/v1/collect/receivers'
    });
};
/**
 * 수신기 토큰 변경/재발급
 */
export const collectControllerReissueReceiverToken = (options) => {
    return (options?.client ?? client).post({
        ...options,
        url: '/v1/collect/receivers/{receiverId}/token/reissue'
    });
};
/**
 * 수신기 토큰 해지
 */
export const collectControllerRevokeReceiver = (options) => {
    return (options?.client ?? client).post({
        ...options,
        url: '/v1/collect/receivers/{receiverId}/revoke'
    });
};
/**
 * 수신기 상태 확인
 */
export const collectControllerGetReceiverStatus = (options) => {
    return (options?.client ?? client).get({
        ...options,
        url: '/v1/collect/receivers/{receiverId}/status'
    });
};
/**
 * 수신함 목록 (receivedAt desc)
 */
export const collectControllerList = (options) => {
    return (options?.client ?? client).get({
        ...options,
        url: '/v1/collect/inbox'
    });
};
/**
 * 수신함 4 카운트 (전체·unclassified·classified·rejected)
 */
export const collectControllerCounts = (options) => {
    return (options?.client ?? client).get({
        ...options,
        url: '/v1/collect/inbox/counts'
    });
};
/**
 * 수신함 row 상세
 */
export const collectControllerGet = (options) => {
    return (options?.client ?? client).get({
        ...options,
        url: '/v1/collect/inbox/{id}'
    });
};
/**
 * BoxHero API 토큰 등록 (owner 만)
 * 토큰을 BoxHero `GET /v1/teams/linked` 로 검증한 뒤 AES-256-GCM 암호화 저장. 등록 시 자동 매핑 + 폴링 repeat job 시작.
 */
export const boxheroIntegrationControllerRegisterToken = (options) => {
    return (options?.client ?? client).post({
        ...options,
        url: '/v1/integrations/boxhero/token'
    });
};
/**
 * BoxHero 토큰 해제 (owner 만)
 * N2 (2026-05-08) — 토큰 NULL · 폴링 repeat 해제 · sync_state paused · mirror cleanup. 옛 ingredient orphan 마킹 영역 영역 폐기 (= ingredient table 폐기). inventory 영역 영역 영향 X.
 */
export const boxheroIntegrationControllerRevokeToken = (options) => {
    return (options?.client ?? client).delete({
        ...options,
        url: '/v1/integrations/boxhero/token'
    });
};
/**
 * BoxHero 통합 상태
 * 응답 — connected, teamName, registeredAt, lastSyncAt, webhookUrl, syncStatus, lastError, defaultLocationId.
 */
export const boxheroIntegrationControllerGetStatus = (options) => {
    return (options?.client ?? client).get({
        ...options,
        url: '/v1/integrations/boxhero/status'
    });
};
/**
 * BoxHero 수동 재동기화 (owner 만)
 * boxhero-initial-sync 큐에 1회 enqueue (jobId 멱등).
 */
export const boxheroIntegrationControllerResync = (options) => {
    return (options?.client ?? client).post({
        ...options,
        url: '/v1/integrations/boxhero/resync'
    });
};
/**
 * BoxHero webhook receiver (무인증)
 * PHASE_4 §6.3 — BoxHero 의 설정 > 연동 > Webhook 메뉴에 등록할 수신 endpoint. 멱등 (id UNIQUE), 즉시 200, 처리는 BullMQ.
 */
export const boxheroWebhookControllerReceive = (options) => {
    return (options?.client ?? client).post({
        ...options,
        url: '/integrations/boxhero/events'
    });
};
/**
 * 앱 사용자 로그인
 * app.dvvb.io 사람 로그인입니다. 윈도우 수신기 인증은 /v2/agent/auth/token-login 을 사용합니다.
 */
export const authPublicControllerLogin = (options) => {
    return (options?.client ?? client).post({
        ...options,
        url: '/v1/auth/login'
    });
};
/**
 * 회사 가입 신청 (무인증, Phase 2.5)
 * 신청 후 운영자(admin) 가 /v1/admin/signups/:id/approve 로 승인하면 회사·사용자·membership 생성. 같은 email 의 동시 pending 신청은 1건만 가능 (충돌 시 409).
 */
export const authPublicControllerSignup = (options) => {
    return (options?.client ?? client).post({
        ...options,
        url: '/v1/auth/signup'
    });
};
/**
 * 가입 신청 목록 (admin)
 */
export const adminControllerListSignups = (options) => {
    return (options?.client ?? client).get({
        ...options,
        url: '/v1/admin/signups'
    });
};
/**
 * 가입 신청 단건
 */
export const adminControllerGetSignup = (options) => {
    return (options?.client ?? client).get({
        ...options,
        url: '/v1/admin/signups/{id}'
    });
};
/**
 * 가입 신청 승인 — 회사·사용자·membership(owner) 트랜잭션 생성
 */
export const adminControllerApproveSignup = (options) => {
    return (options?.client ?? client).post({
        ...options,
        url: '/v1/admin/signups/{id}/approve'
    });
};
/**
 * 가입 신청 거절 — reason 필수
 */
export const adminControllerRejectSignup = (options) => {
    return (options?.client ?? client).post({
        ...options,
        url: '/v1/admin/signups/{id}/reject'
    });
};
/**
 * 회사 목록 + 요약 헬스 (실시간 집계)
 */
export const adminControllerListCompanies = (options) => {
    return (options?.client ?? client).get({
        ...options,
        url: '/v1/admin/companies'
    });
};
/**
 * 회사 단건 풀 헬스 (BoxHero·매장·24h 활동 등)
 */
export const adminControllerGetCompany = (options) => {
    return (options?.client ?? client).get({
        ...options,
        url: '/v1/admin/companies/{id}'
    });
};
/**
 * 회사 삭제 (soft delete, 운영자)
 * deletedAt timestamp 만 set. 모든 Company 조회 query 가 자동 hide. 복구 가능. 사장/직원 login 시 401 (Track B 의 membership filter 효과).
 */
export const adminControllerDeleteCompany = (options) => {
    return (options?.client ?? client).delete({
        ...options,
        url: '/v1/admin/companies/{id}'
    });
};
/**
 * 회사 일시정지 (운영자)
 */
export const adminControllerSuspendCompany = (options) => {
    return (options?.client ?? client).post({
        ...options,
        url: '/v1/admin/companies/{id}/suspend'
    });
};
/**
 * 회사 정지 해제 (운영자)
 */
export const adminControllerUnsuspendCompany = (options) => {
    return (options?.client ?? client).post({
        ...options,
        url: '/v1/admin/companies/{id}/unsuspend'
    });
};
/**
 * 회사 복구 (운영자)
 * deletedAt = null. 회사 status (active/suspended) 보존.
 */
export const adminControllerRestoreCompany = (options) => {
    return (options?.client ?? client).post({
        ...options,
        url: '/v1/admin/companies/{id}/restore'
    });
};
/**
 * 시스템 헬스 — DB·Redis·BullMQ 5 큐 카운트
 */
export const adminControllerSystemHealth = (options) => {
    return (options?.client ?? client).get({
        ...options,
        url: '/v1/admin/system/health'
    });
};
/**
 * 분석 KPI Topline (revenue/orders/aov/costRate/wasteRate/forecastErr)
 */
export const analyticsControllerTopline = (options) => {
    return (options?.client ?? client).get({
        ...options,
        url: '/v1/analytics/topline'
    });
};
/**
 * 일별 매출·주문 — 기간 내 매일 1 row
 */
export const analyticsControllerDaily = (options) => {
    return (options?.client ?? client).get({
        ...options,
        url: '/v1/analytics/daily'
    });
};
/**
 * 시간대(0-23) 분포 — 24 row 고정
 */
export const analyticsControllerHourly = (options) => {
    return (options?.client ?? client).get({
        ...options,
        url: '/v1/analytics/hourly'
    });
};
/**
 * 플랫폼별 (revenue/share/storeCount)
 */
export const analyticsControllerPlatforms = (options) => {
    return (options?.client ?? client).get({
        ...options,
        url: '/v1/analytics/platforms'
    });
};
/**
 * 매장별 list (revenue desc, aov 포함)
 */
export const analyticsControllerStores = (options) => {
    return (options?.client ?? client).get({
        ...options,
        url: '/v1/analytics/stores'
    });
};
/**
 * 메뉴 랭킹 (revenue desc, mergeByCanonical 옵션)
 */
export const analyticsControllerMenus = (options) => {
    return (options?.client ?? client).get({
        ...options,
        url: '/v1/analytics/menus'
    });
};
/**
 * 옵션·토핑 성과 (Phase 5b-2)
 */
export const analyticsControllerToppings = (options) => {
    return (options?.client ?? client).get({
        ...options,
        url: '/v1/analytics/toppings'
    });
};
/**
 * 이상치 감지 — z-score 기반 (Phase 5b-2)
 */
export const analyticsControllerAnomalies = (options) => {
    return (options?.client ?? client).get({
        ...options,
        url: '/v1/analytics/anomalies'
    });
};
/**
 * 키워드 frequency — 메뉴명 토큰 (Phase 5b-2)
 */
export const analyticsControllerKeywords = (options) => {
    return (options?.client ?? client).get({
        ...options,
        url: '/v1/analytics/keywords'
    });
};
/**
 * 재고 사용량 — boxhero out/sale_out 합산 (Phase 5b-2)
 */
export const analyticsControllerInventoryUsage = (options) => {
    return (options?.client ?? client).get({
        ...options,
        url: '/v1/analytics/inventory-usage'
    });
};
/**
 * 레시피 미입력 메뉴 판매 카운트 + 최근 5건 (2026-05-01 [4])
 */
export const analyticsControllerRecipeMiss = (options) => {
    return (options?.client ?? client).get({
        ...options,
        url: '/v1/analytics/recipe-miss'
    });
};
/**
 * 파서 정확도 — 기간 내 receipt 처리 통계 + 실패 sample (admin)
 */
export const parsingAccuracyControllerParsingAccuracy = (options) => {
    return (options?.client ?? client).get({
        ...options,
        url: '/v1/admin/parsing-accuracy'
    });
};
//# sourceMappingURL=services.gen.js.map